import React from 'react';
import { array } from 'prop-types';

import { connect } from 'react-redux';

import { isNil } from 'lodash';

import Tooltip from '@material-ui/core/Tooltip';

import classes from './IssueTypeIcons.module.css';

const Icons = ({issueIds, issueTypes}) => {
    const issueIcons = [];

    issueIds.forEach((issueId, index) => {
        const targetIssue = issueTypes.find(issueType => issueType.id === issueId);

        if (isNil(targetIssue)) return null;

        issueIcons.push(
            <Tooltip
                title={
                    <React.Fragment>
                        <span className={classes.tooltip}>{targetIssue.label}</span>
                    </React.Fragment>
                }
                placement="top-start"
                key={index}
            >
                <img
                    src={`/assets/images/${targetIssue.icon}`}
                    alt={targetIssue.label}
                    role="none"
                    className={classes.hover}
                />
            </Tooltip>
        );
    });

    return (
        <React.Fragment>
            {issueIcons}
        </React.Fragment>
    );
};

const IssueTypeIcons = ({
    issues,
    issueTypes,
    ...props
}) => {
    return (
        <div className={classes.IssueTypeIcons}>
            <Icons issueIds={issues} issueTypes={issueTypes} />
        </div>
    );
};

IssueTypeIcons.defaultProps = {
    issues:     [],
    issueTypes: []
};

IssueTypeIcons.propTypes = {
    issues:     array,
    issueTypes: array
};

const mapStateToProps = state => {
    return {
        issueTypes: state.svcManagement.issueTypes
    };
};

export default connect(mapStateToProps, null)(IssueTypeIcons);
